import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleAuthErrors } from "../../util/helpers/ErrorHelper";

export const AccountController = {
    BaseModel: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        document: "",
        documentType: 0,
        type: 1
    },
    LoginModel: {
        email: "",
        password: "",
    },
    RecoverModel: {
        email: "",
        password: "",
        confirmPassword: "",
        token: "",
    },

    Register: async function (data, response, error){
        await BaseService(
            {
              method: "POST",
              url: "account/signup",
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    ForgotPassword: async function (email, response, error){
        await BaseService(
            {
              method: "POST",
              url: `account/password/forgot/${email}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    PasswordReset: async function (data, response, error){
        await BaseService(
            {
              method: "POST",
              url: `account/password/reset`,
              data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },

    Login: async function (data, response, error){
        await BaseService(
            {
              method: "POST",
              url: "account/signin",
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },

    Update: async function (data, response, error){
        await BaseService(
            {
              method: "PUT",
              url: `account/${data.id}`,
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    Delete: async function (id, response, error){
        await BaseService(
            {
              method: "DELETE",
              url: `account/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },

    Get: async function (id, response, error){
        await BaseService(
            {
              method: "GET",
              url: `account/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },

    Role: async function (id, role, response, error){
        await BaseService(
            {
              method: "PUT",
              url: `account/${id}/role?role=${role}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    Status: async function (id, status, response, error){
        await BaseService(
            {
              method: "PUT",
              url: `account/${id}/status?status=${status}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    ConnectCompany: async function (id, companyId, creator, response, error){
        await BaseService(
            {
              method: "PUT",
              url: `account/${id}/company?companyId=${companyId}&creator=${creator}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    CompanyUsers: async function (companyId, response, error){
        await BaseService(
            {
              method: "GET",
              url: `account/company/${companyId}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
    
    ApproveCompanyUser: async function (userId, status, response, error){
        await BaseService(
            {
              method: "PUT",
              url: `account/company/${userId}/Status?status=${status}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleAuthErrors(err))
        );
    },
}